var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenCheckmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mockup-5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HO-fleet-non-user",
    transform: "translate(-1101.000000, -208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(1101.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#7ED321",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-70",
    transform: "translate(5.000000, 6.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9067816,0.0927427714 C12.7831246,-0.0309142571 12.5821027,-0.0309142571 12.4584456,0.0927427714 L4.75556396,7.7949903 L2.7605639,5.79999024 C2.63690687,5.67633322 2.43588493,5.67633322 2.3122279,5.79999024 L0.0927427714,8.01947537 C-0.0309142571,8.1431324 -0.0309142571,8.34415434 0.0927427714,8.46781137 L4.53171303,12.9067816 C4.65537006,13.0310728 4.856392,13.0310728 4.98004902,12.9067816 L15.1262668,2.7605639 C15.2499238,2.63690687 15.2499238,2.43588493 15.1262668,2.3122279 L12.9067816,0.0927427714 Z",
    id: "Fill-2904"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenCheckmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/greenCheckmark.62d154a384190d41bd67e23fa8dc7c85.svg";